<template>
  <div class="footer container">
    <hr />
    <div class="row">
      <div id="accueil_footer" class="col-lg-3 col-sm-2 col-12">
        <p id="title_accueil">Accueil</p>
        <a class="puces_liens" href="https://www.reseau-colibri.fr/actualites.jsp">Actualités</a>
        <a class="puces_liens" href="https://www.reseau-colibri.fr/billetterie/">Billetterie en ligne</a>
        <a
          class="puces_liens"
          href="https://www.reseau-colibri.fr/assets/pdf/reglement-transport-2020-11-12.pdf"
          >Règlements des transports</a
        >
        <a class="puces_liens" href="https://www.reseau-colibri.fr/contact.jsp"
          >Contact & Service client</a
        >
      </div>

      <div id="reseau_footer" class="col-lg-2 col-sm-2 col-12">
        <p id="title_reseau">Réseau</p>
        <a class="puces_liens" href="https://www.reseau-colibri.fr/urbaines.jsp">Lignes urbaines</a>
        <a class="puces_liens" href="https://www.reseau-colibri.fr/ecoles.jsp">Transport écoles</a>
        <a class="puces_liens" href="https://www.reseau-colibri.fr/tad.jsp">TSR</a>
        <a class="puces_liens" href="https://www.reseau-colibri.fr/plan.jsp">Plans du réseau</a>
      </div>

      <div class="service_toul col-lg-2 offset-lg-1 col-sm-4 col-6">
        <p class="service">Un service mis en place par</p>
        <a target="_blank" href="https://autocars.pretapartir.fr/">
          <img src="../assets/pretapartir.png" alt="prêt à partir" />
        </a>
      </div>

      <div class="col-lg-2 col-sm-2 col-6">
        <a target="_blank" href="https://www.terrestouloises.com/">
          <img src="../assets/logo_terres.png" alt="logo terres touloises" />
        </a>
      </div>

      <div class="col-lg-2 col-sm-2">
        <a id="footer_fb" class="btn" target="_blank" href="https://www.facebook.com/colibrietvous/">
          <i class="fab fa-facebook-f icone_facebook"></i>
        </a>
      </div>
    </div>

    <div id="copyright">
      <p class="cop_texte">
        <a
          class="cop_lien"
          target="_blank"
          href="https://www.reseau-colibri.fr/assets/pdf/mentions_legales.pdf"
        >
          Mentions légales • Politique de confidentialité</a
        >
        • Copyright © 2026 Tous droits réservés.
      </p>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss">
@import '../sass/app';

.footer {
  width: 100%;
  text-align: center;
  margin-top: 4%;

  .service_toul {
    text-align: left;
    padding-left: 1rem;
    padding-right: 1rem;

    .service {
      color: #dadada;
      font-size: 12px;
    }
  }

  #title_accueil,
  #title_reseau {
    text-align: left;
  }

  #accueil_footer,
  #reseau_footer {
    color: $firstcolor;
    margin-bottom: 5%;
  }

  #footer_fb {
    background-color: $facebookcolor;
    border-radius: 50%;

    .icone_facebook {
      color: $white;
    }
  }

  #footer_fb:hover {
    background-color: $white;
    border-radius: 50%;
    border: 2px solid $facebookcolor;

    .icone_facebook {
      color: $facebookcolor;
    }
  }

  #title_accueil,
  #title_reseau {
    font-family: $titlefont;
    font-weight: bold;
  }

  .puces_liens {
    font-family: $textfont;
    color: $black;
    display: flex;
    text-align: left;
    font-size: 13.5px;
  }

  .puces_liens:hover {
    color: $roll-over;
    text-decoration: none;
  }
}

#copyright {
  margin-top: 5%;

  .cop_texte {
    .cop_lien {
      color: #dadada;
    }

    display: inline-flex;
    text-align: end;
    color: #dadada;
    font-family: $textfont;
    font-size: 12px;
  }
}
</style>